import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/shared/base/base-form.component';
import { OptionsSource } from 'src/app/core/core.models';
import { AuthService } from 'src/app/core/auth.service';
import { LoadingService } from 'src/app/core/loading.service';
import { TranslatorService } from 'src/app/core/translator.service';
import { UtilityService } from 'src/app/core/utility.service';
import { Dialog, DialogService } from 'src/app/core/dialog.service';
import { AlertService } from 'src/app/core/alert.service';

import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/app/shared/base/base.service';
import { Constants } from 'src/app/app.constants';
import { ValueLabel } from 'src/app/shared/base/base.models';
import { PolicyUserType, RebatePolicy, RebatePolicyOption, RebatePolicyType } from '../rebate-policies.models';
import { PointsOfSaleService } from '../../points-of-sale/points-of-sale.service';
import { PaymentMethodsService } from '../../payment-methods/payment-methods.service';
import { PromotionalCodeDocumentsService } from '../../promotional-code-documents/promotional-code-documents.service';
import { TranslateService } from '@ngx-translate/core';
import { PointOfSale } from '../../points-of-sale/points-of-sale.models';
import { PromotionalCodeDocument } from '../../promotional-code-documents/promotional-code-documents.models';
import { PaymentMethod } from '../../payment-methods/payment-methods-models';
import { Product } from '../../products/products.models';
import { ProductsService } from '../../products/products.service';
import { GiftPackageService } from '../../gift-package/gift-package.service';
import { AttributeSelection, ProductAttributeType } from '../../product-catalogues/product-catalogues.models';
import { ProductClassificationService } from 'src/app/shared/product-classification/product-classification.service';
import { MeansOfDeliveryService } from '../../means-of-delivery/means-of-delivery.service';
import { Type } from '../../means-of-delivery/means-of-delivery.models';


@Component({
  selector: 'app-rebate-policies-form',
  templateUrl: './rebate-policies-form.component.html',
  styleUrls: ['./rebate-policies-form.component.scss']
})
export class RebatePoliciesFormComponent extends BaseFormComponent implements OnInit {
  public tabs: string[] = ['PRODUCTS'];
  public products: Product[] = [];
  public productsSource: OptionsSource;
  public selectedProduct: Product;

  public rebatePolicyTypes: ValueLabel[] = [];
  public rebatePolicyOptions: ValueLabel[] = [];
  public rebatePolicyUserTypes: ValueLabel[] = [];
  public productAttributeTypes: ValueLabel[] = [];
  public meansOfDeliveryTypes: ValueLabel[] = [];
  public productAttributesSource: OptionsSource;

  public rebatePolicyOption: RebatePolicyOption;
  public rebatePolicyType: RebatePolicyType;
  public RebatePolicyType = RebatePolicyType;

  public pointsOfSale: OptionsSource;
  public paymentMethods: OptionsSource;
  public promotionalCodeDocuments: OptionsSource;
  public giftPackages: OptionsSource;

  public minDateFrom: Date = new Date();

  public isProductsModalVisible: boolean = false;
  public isAddByAttributeModalVisible: boolean = false;
  public productAttributeType: string;
  public productAttributes: string[] = [];

  public showPercentage: boolean = false;
  public showPromoCode: boolean = false;
  public showGift: boolean = false;

  public showReferencePeriod: boolean = false;
  public showSequential: boolean = false;
  public showPaymentMethod: boolean = false;
  public showMeanOfDelivery: boolean = false;

  constructor(
    private meansOfDeliveryService: MeansOfDeliveryService,
    private productClassificationService: ProductClassificationService,
    private giftPackageService: GiftPackageService,
    private productsService: ProductsService,
    private pointsOfSaleService: PointsOfSaleService,
    private paymentMethodsService: PaymentMethodsService,
    private promotionalCodeDocumentsService: PromotionalCodeDocumentsService,
    private translateService: TranslateService,
    public authService: AuthService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    protected baseService: BaseService,
    protected dialogService: DialogService,
    protected router: Router,
    protected alertService: AlertService
  ) {
    super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService)
  }


  ngOnInit(): void {
    this.authorities.init('CD_CD', 'R_CD', 'U_CD', 'CD_CD');
    this.url = `${Constants.contextPath}/rebate-policies`;
    this.prepareLookupData();
    this.prepareFormData(new RebatePolicy(), (response: RebatePolicy) => {
      return this.modifyResponse(response);
    });
  }

  prepareLookupData() {
    this.rebatePolicyTypes = this.getPolicyTypes(false);
    this.rebatePolicyOptions = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(RebatePolicyOption, true), 'value', 'label', 'ENUMS.REBATE_POLICY_OPTIONS.');
    this.rebatePolicyUserTypes = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(PolicyUserType, true), 'value', 'label', 'ENUMS.REBATE_POLICY_USER_TYPES.');
    this.productAttributeTypes = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(ProductAttributeType, true), 'value', 'label', 'PRODUCTS.');
    this.meansOfDeliveryTypes = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(Type, true), 'value', 'label', 'ENUMS.DELIVERY_TYPES.');

    this.pointsOfSale = this.pointsOfSaleService.getPointsOfSaleOptions();
    this.paymentMethods = this.paymentMethodsService.getPaymentMethodsOptions();
    this.promotionalCodeDocuments = this.promotionalCodeDocumentsService.getPromotionalCodeDocumentsOptions();
    this.giftPackages = this.giftPackageService.getGiftPackagesOptions();

    this.productsSource = this.productsService.getProductsOptions();
  }

  public onToolbarPreparing($event: any): void {
    if (this.authorities.create || this.authorities.update) {
      $event.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'plus',
          hint: this.translateService.instant('DEV-EXTREME.dxDataGrid-editingAddRow'),
          text: this.translateService.instant('DEV-EXTREME.dxDataGrid-editingAddRow'),
          showText: 'inMenu',
          onClick: this.openProductsModal.bind(this)
        },
        locateInMenu: 'auto'
      });

      $event.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'trash',
          hint: this.translateService.instant('SHARED.DELETE_ALL'),
          text: this.translateService.instant('SHARED.DELETE_ALL'),
          showText: 'inMenu',
          onClick: this.deleteAllProducts.bind(this)
        },
        locateInMenu: 'auto'
      });

      let self = this;
      $event.toolbarOptions.items.unshift({
        widget: 'dxButton',
        options: {
          icon: 'plus',
          hint: this.translateService.instant('PRODUCT_CATALOGUES.ADD_BY_ATTRIBUTE'),
          text: this.translateService.instant('PRODUCT_CATALOGUES.ADD_BY_ATTRIBUTE'),
          showText: 'always',
          onClick: function () {
            // event.component.openAddByAttributeModal();
            self.openAddByAttributeModal();
          }
        },
        location: 'after',
        locateInMenu: 'auto'
      });
    }
  }

  public openAddByAttributeModal() {
    this.isAddByAttributeModalVisible = true;
  }

  public attributeTypeChanged(event) {
    if (this.productAttributeType != event.value) {
      this.productAttributeType = event.value;
      this.productAttributes = [];
      this.productAttributesSource = this.productClassificationService.getAttributesByType(event.value);
    }
  }

  public closeAddByAttributeModal() {
    this.productAttributeType = null;
    this.productAttributes = [];
    this.isAddByAttributeModalVisible = false;
  }

  public addByAttribute() {
    let data = new AttributeSelection();
    data.productAttributeType = this.productAttributeType;
    data.productAttributes = this.productAttributes;
    this.productsService.getProductsByAttribute(data, (response) => {
      for (let product of response)
        if (this.products.findIndex(p => p.id == product.id) == -1) {
          this.products.push(product);
          this.pendingChanges = true;
        }
      this.closeAddByAttributeModal();
    })
  }

  public selectedProductChanged(event) {
    if (event && event.selectedItem) {
      this.selectedProduct = event.selectedItem;
    }
  }

  public openProductsModal() {
    this.isProductsModalVisible = true;
  }

  public closeProductsModal() {
    this.selectedProduct = null
    this.isProductsModalVisible = false;
  }

  public addProduct() {
    if (this.selectedProduct) {
      if (!this.products.find(p => p.id == this.selectedProduct.id)) {
        this.products.push(this.selectedProduct);
        this.closeProductsModal();
        this.pendingChanges = true;
      } else {
        this.alertService.error('REBATE_POLICIES.PRODUCT_EXISTS');
      }
    } else {
      this.alertService.error('REBATE_POLICIES.PRODUCT_FORM_INVALID');
    }
  }

  public removeProduct(id: string): void {
    let dialog = new Dialog('SHARED.DELETE_QUESTION', () => {
      this.products = this.products.filter(function (p) {
        return p.id !== id;
      });
      this.alertService.success('SHARED.DELETE_SUCCESS');
    });

    this.dialogService.show(dialog);
  }

  public deleteAllProducts() {
    let dialog = new Dialog('REBATE_POLICIES.DELETE_ALL_PRODUCTS', () => {
      this.products = [];
      this.alertService.success('REBATE_POLICIES.DELETE_ALL_PRODUCTS_SUCCESS');
    });

    this.dialogService.show(dialog);
  }

  public modifyResponse(response: RebatePolicy) {
    response.breadcrumbsId = response.documentNumber;

    if (response.pointOfSale) {
      let pointOfSale = <PointOfSale>response.pointOfSale;
      response.pointOfSale = pointOfSale.id;
    }

    if (response.promotionalCodeDocument) {
      let promotionalCodeDocument = <PromotionalCodeDocument>response.promotionalCodeDocument;
      response.promotionalCodeDocument = promotionalCodeDocument.id;
    }

    if (response.paymentMethod) {
      let paymentMethod = <PaymentMethod>response.paymentMethod;
      response.paymentMethod = paymentMethod.id;
    }

    if (response.products) {
      this.products = <Product[]>response.products;
    }


    if (response.type) {
      this.disableFieldsBasedOnTypeValue(response.type);
    }

    return response;
  }

  public saveChanges(): void {
    if (!this.isFormValid())
      return;

    if (this.products)
      this.formData.products = this.products.map(p => p.id);

    if (this.formData.giftPackages)
      this.formData.giftPackages = this.formData.giftPackages.map(g => g.id ? g.id : g);

    if (!this.formData.minimalOrderValue || this.formData.minimalOrderValue < 0) // TODO kad V stavi default u bazu, izbrisati
      this.formData.minimalOrderValue = 0;     

    if (this.id == null)
      this.baseService.create(this.url, this.formData, () => {
        this.onSaveSuccess();
      });
    else
      this.baseService.update(this.url, this.formData, () => {
        this.onSaveSuccess();
      });
  }

  public typeChanged = (event) => {
    this.disableFieldsBasedOnTypeValue(event.value, true)
  }

  private disableFieldsBasedOnTypeValue(value, alterData = false) {
    this.rebatePolicyType = value;
    switch (value) {
      case RebatePolicyType[RebatePolicyType.PERCENT]:
        this.showPercentage = this.showPromoCode = true;
        this.showGift = false;

        // if (alterData) {
        //   this.formData.promotionalCodeDocument = null;
        // }
        break;
      case RebatePolicyType[RebatePolicyType.PROMO_CODE]:
        this.showPromoCode = true;
        this.showPercentage = this.showGift = false;

        if (alterData) {
          this.formData.percentage = null;
        }
        break;
      case RebatePolicyType[RebatePolicyType.GIFT]:
        this.showPromoCode = this.showPercentage = false;
        this.showGift = true;

        if (alterData) {
          this.formData.promotionalCodeDocument = null;
          this.formData.percentage = null;
        }
        break;
    }
  }

  public onOptionChanged = (event) => {
    let previousValuePromoCode = event.previousValue == RebatePolicyOption[RebatePolicyOption.PROMO_CODE];

    switch (event.value) {
      case RebatePolicyOption[RebatePolicyOption.MEANS_OF_DELIVERY]:

        this.showMeanOfDelivery = true
        this.showReferencePeriod = this.showSequential = this.showPaymentMethod = this.showPromoCode = false;

        this.formData.orderSequentialNumber = this.formData.paymentMethod = null;

        if (previousValuePromoCode)
          this.rebatePolicyTypes = this.getPolicyTypes();

        this.rebatePolicyOption = event.value;
        
        break;
      case RebatePolicyOption[RebatePolicyOption.TOTAL_ORDERS_PERIOD]:

        this.showReferencePeriod = true;
        this.showSequential = this.showPaymentMethod = this.showMeanOfDelivery = this.showPromoCode = false;

        this.formData.orderSequentialNumber = this.formData.paymentMethod = null;

        if (previousValuePromoCode)
          this.rebatePolicyTypes = this.getPolicyTypes();

        this.rebatePolicyOption = event.value;
        
        break;
      case RebatePolicyOption[RebatePolicyOption.SEQUENTIAL_ORDER]:

        this.showSequential = this.showReferencePeriod = true;
        this.showPaymentMethod = this.showMeanOfDelivery = this.showPromoCode = false;

        this.formData.referencePeriodFrom = this.formData.referencePeriodTo = this.formData.paymentMethod = null;

        if (previousValuePromoCode)
          this.rebatePolicyTypes = this.getPolicyTypes();

        this.rebatePolicyOption = event.value;
        
        break;
      case RebatePolicyOption[RebatePolicyOption.PROMO_CODE]:

        this.showPromoCode = true;
        this.showPaymentMethod = this.showReferencePeriod = this.showSequential = this.showMeanOfDelivery = false;

        if (this.formData.type == RebatePolicyType[RebatePolicyType.PROMO_CODE])
          this.formData.type = null;

        this.formData.promoCode = this.formData.orderSequentialNumber = this.formData.referencePeriodFrom = this.formData.referencePeriodTo = this.formData.paymentMethod = null;

        this.rebatePolicyTypes = this.getPolicyTypes(true);
        this.rebatePolicyOption = event.value;
        break;
      case RebatePolicyOption[RebatePolicyOption.PAYMENT_METHOD]:
        this.showPaymentMethod = true;
        this.showReferencePeriod = this.showSequential = this.showMeanOfDelivery = this.showPromoCode = false;

        this.formData.orderSequentialNumber = this.formData.referencePeriodFrom = this.formData.referencePeriodTo = null;

        if (previousValuePromoCode)
          this.rebatePolicyTypes = this.getPolicyTypes();

        this.rebatePolicyOption = event.value;
        
        break;
      case RebatePolicyOption[RebatePolicyOption.ORDER_VALUE]:
        this.showReferencePeriod = this.showSequential = this.showPaymentMethod = this.showMeanOfDelivery = this.showPromoCode = false;

        this.formData.orderSequentialNumber = this.formData.referencePeriodFrom = this.formData.referencePeriodTo = this.formData.paymentMethod = null;

        if (previousValuePromoCode)
          this.rebatePolicyTypes = this.getPolicyTypes();
        this.rebatePolicyOption = event.value;

        break;
    }

    this.form.instance.repaint();
  }

  public getPolicyTypes(removePromoCode: boolean = false) {
    let rebatePolicyTypes = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(RebatePolicyType, true), 'value', 'label', 'ENUMS.REBATE_POLICY_TYPES.');

    if (removePromoCode) {
      if (this.formData.type == RebatePolicyType[RebatePolicyType.PROMO_CODE])
        this.formData.type = null;
      let index = rebatePolicyTypes.findIndex(type => type.value == RebatePolicyType[RebatePolicyType.PROMO_CODE]);
      if (index > -1)
        rebatePolicyTypes.splice(index, 1);
    }

    return rebatePolicyTypes;
  }
}
